import { KeyboardEvent } from 'react';

export const handleCreditInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
  const restrictedKeys = /^[-+e,]$/;
  if (restrictedKeys.test(event.key)) {
    event.preventDefault();
  }
};
